class ModalFilters extends ModalDialog {
    constructor() {
        super();
        
    }
    connectedCallback() {
        // console.log('connectedCallback');
    }

}

customElements.define('modal-filters', ModalFilters);